import { useEffect, useState } from 'react';

import httpClient from '../httpClient';

export async function getAllDenominacoesGenericas() {
  try {
    const response = await httpClient.get(`/api/denominacaogenerica`);
    return Array.isArray(response.data.denominacoesGenericas)
      ? response.data.denominacoesGenericas
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Denominações Genéricas: ' + error);
  }
}

export async function getDenominacoesGenericasPorUsuario() {
  try {
    const response = await httpClient.get(
      '/api/denominacaogenerica/denominacoes-por-usuario',
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error(
      'Erro ao obter Denominações Genéricas por usuário: ' + error,
    );
  }
}

export async function getDenominacaoGenerica(denominacaoGenericaID: string) {
  try {
    const response = await httpClient.get(
      `/api/denominacaogenerica/${denominacaoGenericaID}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Denominação Genérica: ' + error);
  }
}

interface DenominacaoGenericaOption {
  id: number;
  tipoProduto: number;
  denominacao: string;
}

export const useListaDenominacoesGenericas = () => {
  const [registroEnum, setRegistroEnum] = useState<DenominacaoGenericaOption[]>(
    [],
  );

  useEffect(() => {
    const fetchRegistroEnum = async () => {
      try {
        const response = await httpClient.get(
          `/api/denominacaogenerica/listadenominacoesgenericas`,
        );

        const options = response.data.map(
          (registro: {
            id: number;
            tipoProduto: number;
            denominacao: string;
          }): DenominacaoGenericaOption => ({
            id: registro.id,
            tipoProduto: registro.tipoProduto,
            denominacao: registro.denominacao,
          }),
        );
        setRegistroEnum(options);
      } catch (error) {
        console.error('Erro ao buscar dados.', error);
      }
    };

    fetchRegistroEnum();
  }, []);

  return registroEnum;
};

interface DenominacaoOption {
  id: number;
  denominacao: string;
}

export const useDenominacaoPorComponente = (componente: string | null) => {
  const [registroEnum, setRegistroEnum] = useState<DenominacaoOption[]>([]);

  useEffect(() => {
    if (!componente) return; // Não faz a chamada se o componente não for válido

    const fetchRegistroEnum = async () => {
      try {
        const response = await httpClient.get(
          `/api/denominacaogenerica/denominacoes-por-componente/${componente}`,
        );

        const options = response.data.map(
          (registro: {
            id: number;
            denominacao: string;
          }): DenominacaoOption => ({
            id: registro.id,
            denominacao: registro.denominacao,
          }),
        );
        setRegistroEnum(options);
      } catch (error) {
        console.error('Erro ao buscar dados.', error);
      }
    };

    fetchRegistroEnum();
  }, [componente]); // Atualiza os dados quando o componente muda

  return registroEnum;
};
